import { render, staticRenderFns } from "./modalDuplicarCuponVendedor.vue?vue&type=template&id=4432e5c6&"
import script from "./modalDuplicarCuponVendedor.vue?vue&type=script&lang=js&"
export * from "./modalDuplicarCuponVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports